<template lang="">
    <div>    
        <v-card-text>
            <v-row>
                <v-col cols="2">
                    <v-btn color="green" dark @click="abrirModal()" v-if="can_manipulate">
                        Crear Nuevo Menú
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-col>

                <v-col> </v-col>

                <v-col cols="2">
                    <v-btn color="green" dark @click="limpiarFiltros">
                        Limpiar Filtros
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>

        <v-data-table
            :headers="cabeceras_menus"
            :items="menus_filtrados"
            :items-per-page="20"
            item-class="filita"
            class="elevation-2 mt-1"
            dense
        >
            <template v-slot:header="{ item }">
                <tr>
                    <th v-for="cab in cabeceras_menus" class="filita px-2">
                        <v-text-field
                            v-if="cab.value === 'texto'"
                            label="Buscar por nombre"
                            v-model="filtros.texto"
                        ></v-text-field>
                        <v-select
                            v-else-if="cab.value === 'sistema'"
                            v-model="filtros.sistema"
                            :items="[
                                { nombre: 'Todos', value: '' },
                                { nombre: 'Romana', value: 'romana' },
                                { nombre: 'Producción', value: 'produccion' },
                            ]"
                            label="Sistema"
                            item-text="nombre"
                            item-value="value"
                            color="blue darken-3"
                            persistent-hint
                        ></v-select>
                    </th>
                </tr>
            </template>
            <template v-slot:item.icono="{ item }">
                <span
                    ><v-icon>{{ item.icono }}</v-icon></span
                >
            </template>
            <template v-slot:item.roles="{ item }">
                <v-select
                    v-model="item.roles"
                    :items="item.roles"
                    item-text="name"
                    item-value="id"
                    label="Roles"
                    multiple
                    readonly
                    small-chips
                ></v-select>
            </template>
            <template v-slot:item.opciones="{ item }">
                <template v-if="can_manipulate">
                    <v-icon @click="abrirModal(item)" color="blue" class="mx-2" title="Modificar roles de menú"
                    >edit</v-icon
                    >
                    <v-icon @click="eliminarMenu(item)" color="red" class="mx-2" title="Eliminar menú"
                        >delete</v-icon
                    >
                </template>
                <v-icon color="warning" title="No tienes permitido realizar estas acciones" v-else>info</v-icon>
            </template>
        </v-data-table>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'

export default {
    data: () => ({
        cabeceras_menus:[
                { text: 'TEXTO MENÚ',   align: 'center',    sortable: true,     value: 'texto',     class: 'cabecera',},
                { text: 'SISTEMA',      align: 'center',    sortable: true,     value: 'sistema',   class: 'cabecera',},
                { text: 'RUTA',         align: 'center',    sortable: true,     value: 'ruta',      class: 'cabecera',},
                { text: 'ICONO',        align: 'center',    sortable: true,     value: 'icono',     class: 'cabecera',},
                { text: 'ORDEN',        align: 'center',    sortable: true,     value: 'orden',     class: 'cabecera',},
                { text: 'DEBAJO DE',    align: 'center',    sortable: true,     value: 'debajo_de', class: 'cabecera',},
                { text: 'ROLES',        align: 'center',    sortable: true,     value: 'roles',     class: 'cabecera',},
                { text: 'OPCIONES',     align: 'center',    sortable: true,     value: 'opciones',  class: 'cabecera',},
            ],
        menus: [],
        filtros: {
            texto: "",
            sistema: "",
        },
    }),
    props: {
        roles: Array,
        can_manipulate: Boolean,
    },
    mounted() {
        this.cargarMenus();
    },
    methods: {
        async cargarMenus() {
            this.mostrarLoading({ titulo: "Cargando menús...", color: "green" })
            const url = `${this.base_url}menus`;
            await this.axios.get(url, this.headers).then(res => {
                console.log({menus: res.data.data});
                this.menus = res.data.data;
                this.ocultarLoading();
            }).catch(error => {
                console.error('error',error);
                this.errorMessage(error, "Error al cargar menús");
            });
        },
        abrirModal(item = null) {
            if(item) {
                this.$emit('abrir_modal_create', item);
            } else {
                this.$emit('abrir_modal_create');
            }
        },
        limpiarFiltros() {
            for (const key in this.filtros) {
                this.filtros[key] = "";
            }
        },
        async eliminarMenu(item) {
            if(item.roles.length > 0) {
                this.errorMessage("ERROR", "Este menú tiene roles asociados. Para eliminarlo, elimine sus roles asociados.");
            } else {
                const url = `${this.base_url}menus/${item.id}`;
                const ok = await this.$refs.confirmDialogue.show({
                    title: 'Confirmar eliminación',
                    message: `¿Desea eliminar menú ${item.texto}?`,
                    okButton: '¡Eliminar!',
                })
                if(ok) {
                    this.mostrarLoading({titulo: `Eliminando menú ${item.texto}...`, color: "red"});
                    await this.axios.delete(url, this.headers).then(response => {
                        this.cargarMenus()
                        this.ocultarLoading();
                    }).catch(error => {
                        console.error(error);
                        this.errorMessage(error, "Error al eliminar ");
                    });
                }
            }
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        menus_filtrados() {
            return this.menus.filter(menu => {
                let filtrado = true;
                if(this.filtros.texto) {
                    filtrado = menu.texto.toLowerCase().includes(this.filtros.texto.toLowerCase());
                    if(!filtrado) return false;
                } 
                if(this.filtros.sistema) {
                    filtrado = menu.sistema === this.filtros.sistema;
                    if(!filtrado) return false;
                }
                return filtrado;
            });
        },
        ...mapState(['base_url','headers']),
    },
    components: {
        ConfirmDialogue,
    }
};
</script>

<style scoped>
</style>
